const DEFAULT_DEV_OPTIONS = {
  useTextRecall: false,
  pageSize: 20,
  rankingWeights: {
    semanticWeight: 0.4,
    salesWeight: 0.15,
    contentWeight: 0.1,
    reviewWeight: 0.15,
    rewardWeight: 0.1,
    priceWeight: 0.1
  }
};
export {
  DEFAULT_DEV_OPTIONS
};
//# sourceMappingURL=devOptions.js.map
